import React from "react";
import "./scss/manager-footer.scss";

export default function ManagerFooter() {
  return (
    <div className="manager-footer">

      <div className="manager-footer__top">

        <div className="manager-footer__brand">
          <img src="/images/floyaLogo.png" alt="Floya" />
        </div>

        <div className="manager-footer__contacts">
          <span className="manager-footer__question">
            Есть вопросы? Звоните:
          </span>

          <a href="tel:+74951284848" className="manager-footer__phone">
            +7 (495) 128 48 48
          </a>

          <span className="manager-footer__worktime">
            Пн. – Пт.: с 8:00 до 19:00
          </span>
        </div>

      </div>

      <div className="manager-footer__links">
        <a href="#">Публичная оферта</a>
        <a href="#">Политика конфиденциальности</a>
        <a href="#">Реквизиты</a>
        <a href="#">Пример ссылки</a>
        <a href="#">Пример ссылки</a>
        <a href="#">Пример ссылки</a>
      </div>

      <div className="manager-footer__payments">
        <span>МИР</span>
        <span>Mastercard</span>
        <span>Visa</span>
      </div>

      <div className="manager-footer__socials">
        <div className="vk">VK</div>
        <div className="inst">IG</div>
        <div className="tg">TG</div>
        <div className="wa">WA</div>
        <div className="yt">YT</div>
      </div>

      <div className="manager-footer__copyright">
        © 2024 ООО «ФЛОЯ»
      </div>

    </div>
  );
}
